import { routes } from 'config/routes';
import { i18nextConfig, initialGlobalState } from 'core/config';
import i18next from 'i18next';
import ReactDOM from 'react-dom';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import React from 'reactn';
import App from './core/components/App/App';
import * as serviceWorker from './serviceWorker';
import './styles';
import {
  LOGIN_AUTHENCATION_ROUTE,
  LOGIN_ROUTE,
  LOGIN_SSO_WAITING_PAGE,
  PPF_ROUTE,
} from 'config/route-consts';
import LoginSSOWaitingPage from 'components/Login/LoginSsoWaitingPage';
import LoginSSO from 'components/Login/LoginSSO';
import Login from 'components/Login/Login';
import { getParameterByName } from 'core/helpers/query';

Promise.all([
  React.setGlobal(initialGlobalState),
  i18next.use(initReactI18next).init(i18nextConfig),
]).then(() => {
  ReactDOM.render(
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path={LOGIN_ROUTE}
          render={() => {
            // Luon di qua luong SSO that, khong dua vao localStorage['profile'] de quyet dinh
            // "da dang nhap" - key nay khong tu het han cung JWT Token nen truoc day gay
            // vong lap redirect vo han khi Token het han nhung profile van con trong localStorage.
            // Giu lai redirect (neu co) de LoginSsoWaitingPage dua nguoi dung quay lai dung trang
            // nghiep vu ban dau sau khi dang nhap xong.
            const redirect = getParameterByName('redirect');
            if (redirect) {
              sessionStorage.setItem('postLoginRedirect', redirect);
            }
            return <LoginSSO />;
          }}
        />
        <Route
          exact
          path={LOGIN_SSO_WAITING_PAGE}
          component={LoginSSOWaitingPage}
        />
        <Route exact path={LOGIN_AUTHENCATION_ROUTE} component={Login} />
        <App routes={routes} />
      </Switch>
    </BrowserRouter>,
    document.getElementById('root'),
  );
});

serviceWorker.unregister();
